import {
  type BigDecimal,
  createBigDecimal,
  greaterThan,
  times,
} from '@0xtorch/big-decimal'

export const updateCostBy5PercentRule = (
  cost: BigDecimal,
  value: BigDecimal,
): BigDecimal => {
  const value5Percent = times(value, createBigDecimal(5n, 2), 6)
  if (greaterThan(value5Percent, cost)) {
    return value5Percent
  }
  return cost
}
